import LandingScreen from "./LandingScreen";
import NewHeaven from "./NewHeaven";
import NewHeavenFactions from "./NewHeavenFactions";
import ParallaxScene from "./ParallaxScene";

export const homepageScreens = [
    <LandingScreen />,
    <NewHeaven />,
    <NewHeavenFactions />,
    <ParallaxScene />,
]